<template>
  <div class="pump4ColumnTable_ctn" :style="style" :class="{ size2 }">
    <div class="pump4ColumnTable_titleRow pump4ColumnTable_titleRow--top roundedCorner-t-l roundedCorner-t-r" v-if="showHeader">
      <div class="highLowTable-titleRow_content pump4ColumnTable_border--right">{{ $t('High BG Event') }}</div>
      <div class="highLowTable-titleRow_content">{{ $t('Low BG Event') }}</div>
    </div>
    
    <div class="pump4ColumnTable_descriptionRow" v-for="v in rowNums" :key="`pump4ColumnTable_row${v}_${id}`" :class="{ 'pump4ColumnTable_descriptionRow': true, 'pump4ColumnTable_titleRow--top': !showHeader && +v === 1, 'roundedCorner-t-l': +v === 1 && !showHeader, 'roundedCorner-t-r': +v === 1 && !showHeader, 'roundedCorner-b-l': +v === rowNums, 'roundedCorner-b-r': +v === rowNums }">
      <div :class="{ 'pump4ColumnTable_descriptionRow--label': true, 'roundedCorner-t-l': +v === 1 && !showHeader, 'roundedCorner-b-l': +v === rowNums }">
        {{ list[v - 1] ? list[v - 1]['column0'] : '' }}
      </div>
      <div :class="{ 'pump4ColumnTable_descriptionRow--content': true }">
      {{ list[v - 1] && list[v - 1]['column1'] ? `${list[v - 1]['column1']}` : '' }}{{ list[v - 1] && list[v - 1]['column1'] ? 'U/h' : ''}}
      </div>
      <div :class="{ 'pump4ColumnTable_descriptionRow--label': true }">
        {{ list[v - 1] ? list[v - 1]['column2'] : '' }}
      </div>
      <div :class="{ 'pump4ColumnTable_descriptionRow--content': true, 'roundedCorner-t-r': +v === 1 && !showHeader, 'roundedCorner-b-r': +v === rowNums }">
      {{ list[v - 1] && list[v - 1]['column3'] ? `${list[v - 1]['column3']}` : '' }}{{ list[v - 1] && list[v - 1]['column3'] ? 'U/h' : ''}}
      </div>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
const derror = derrorFactory('Pump4ColumnTable.vue', true)
const error = errorFactory('Pump4ColumnTable.vue', true)

let _id = 1
export default {
  name: 'CPump4ColumnTable',
  mixins: [reDrawTrigger],
  components: {
  },
  props: {
    width: {
      type: [String, Number],
      default: 455
    },
    size2: {
      type: [Number, Boolean, String],
      default: false
    },
    list: {
      type: [Array],
      default: () => []
    },
    rowNums: {
      type: [Number],
      default: 10
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    showHeader: {
      type: [Number, Boolean, String],
      default: false
    }
  },
  data() {
    _id++
    const id = `pump2columnstable_${+new Date()}_${_id}`
    
    return {
      id
    }
  },
  computed: {
    style() {
      const { showMarginRight, zoomRatio, width } = this
      const rst = { zoom: zoomRatio, width: `${width}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const i = `${rowIndex}`
      if (i === '0') {
        return 'first-row'
      } else if (i === '11') {
        return 'last-row'
      }
      return ''
    },
    tableCellClassName({ row = {}, column = {}}) {
      const { isSum = false } = row
      const { property = '' } = column
      const ps = `${property}`
      if (ps === 'cell11') {
        return 'corner_cell--bright'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

.pump4ColumnTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .pump4ColumnTable_titleRow {
        @include bBox;
        height: $rowH;
        /* @include heightMiddle($rowH); */
        @include flexRow(flex-start, center);
        .highLowTable-titleRow_content {
            @include bBox;
            width: 50%;
            flex-shrink: 1;
            text-align: center;
        }
    }
    .pump4ColumnTable_border--right {
        border-right: 1px solid $colorGluMesurementInnerBorder;
    }
    .pump4ColumnTable_titleRow, .pump4ColumnTable_descriptionRow {
        @include bBox;
        /* @include heightMiddle($rowH); */
        height: $rowH;
        overflow: hidden;
        /* min-height: $rowH; */
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.pump4ColumnTable_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.pump4ColumnTable_titleRow--top {
            /* text-indent: 20px; */
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    .pump4ColumnTable_descriptionRow {
        @include flexRow;
        .pump4ColumnTable_descriptionRow--label, .pump4ColumnTable_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            height: 100%;
            min-height: $rowH;
            width: 25%;
            @include flexColumn(center, center)
        }
        .pump4ColumnTable_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.pump4ColumnTable_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.pump4ColumnTable_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
    }
    
    &.size2 {        
        .pump4ColumnTable_titleRow, .pump4ColumnTable_descriptionRow {
            @include bBox;
            height: $rowH2;
        }
        .pump4ColumnTable_descriptionRow {
            .pump4ColumnTable_descriptionRow--label, .pump4ColumnTable_descriptionRow--content {
                min-height: $rowH;
            }
        }
    }
}
</style>
